var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("confirmation-dialogue", {
    attrs: { id: "protocol-summarization-confirmation-popup" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (cd) {
          return [
            _c("on-off", {
              attrs: {
                options: { id: cd.$props.id, onEsc: false, onBody: false },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (onoff) {
                      return [
                        onoff.ison
                          ? _c("div", { staticClass: "atmo-popup-wrapper" }, [
                              _c("div", { staticClass: "atmo-popup-content" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "atmo-button--small atmo-close",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return cd.cancel.apply(null, arguments)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "atmo-icon-close" })]
                                ),
                                _c("header", [
                                  _c("h5", [_vm._v("Уважаемый пользователь!")]),
                                ]),
                                _c("main", [
                                  _c("p", [
                                    _vm._v(
                                      "Обращаем Ваше внимание, что данное действие необратимо."
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      'Нажимая кнопку "Сформировать итоговый протокол" Вы подтверждаете выбор поставщика для данной закупки.'
                                    ),
                                  ]),
                                ]),
                                _c("footer", [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "atmo-buttons atmo-align-right",
                                    },
                                    [
                                      _c("li", [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "atmo-button-inverse atmo-dimmed",
                                            on: { click: cd.cancel },
                                          },
                                          [_vm._v("Отмена")]
                                        ),
                                      ]),
                                      _c("li", [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "atmo-button",
                                            on: { click: cd.confirm },
                                          },
                                          [
                                            _vm._v(
                                              "Сформировать итоговый протокол"
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }